// Generated by purs version 0.15.15
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var statusSuccess = "success";
var statusLoading = "loading";
var statusError = "error";
var setStatus = function (env) {
    return function (value) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.status))(value);
    };
};
var setErrorMessage = function (env) {
    return function (message) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(env.errorMessage))(message);
    };
};
var setErrorState = function (env) {
    return function (message) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ setStatus(env)(statusError), setErrorMessage(env)(message) ]);
    };
};
var runStorageRemove = function (v) {
    return function (key) {
        return v(key);
    };
};
var pendingEmailKey = "pendingEmailValidationEmail";
var missingTokenMessage = "Missing or invalid verification token";
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/email_validation_controller.md";
var defaultErrorMessage = "We could not verify this link.";
var formatErrorMessage = function (errorValue) {
    var message = Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message);
    var $6 = message === "";
    if ($6) {
        return defaultErrorMessage;
    };
    return message;
};
var handleError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(setErrorState(env)(formatErrorMessage(errorValue)));
    };
};
var clearErrorMessage = function (env) {
    return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.errorMessage))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
};
var setLoadingState = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ setStatus(env)(statusLoading), clearErrorMessage(env) ]);
};
var setSuccessState = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(env.pendingValidation)(false), runStorageRemove(env.storageRemove)(pendingEmailKey), setStatus(env)(statusSuccess), clearErrorMessage(env) ]);
};
var handleVerification = function (env) {
    return function (token) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleError(env))(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(setSuccessState(env));
        })(env.client.verify(token));
    };
};
var buildEmailValidationTask = function (env) {
    return function (token) {
        var $7 = token === "";
        if ($7) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(setErrorState(env)(missingTokenMessage));
        };
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return handleVerification(env)(token);
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(setLoadingState(env)));
    };
};
var mkEmailValidationController = function (env) {
    return {
        runValidation: function (token) {
            return buildEmailValidationTask(env)(token);
        }
    };
};
export {
    mkEmailValidationController,
    documentationPath
};
//# sourceMappingURL=index.js.map
